export const gitVersion = 'map-editor-1.0.13-525-g27f44235';
